import './Basic.css';

function Terms() {

    return (
    <div className="Terms">
        <main>
            <h1>Catastrobee Terms of Service</h1>
            <ol>
                <li>Catastrobee is a stop motion film. This website allows fans to sign up for SMS reminders, updates, and promotional content related to the film. It also enters users into a raffle a giveaway for a free t-shirt.</li>
                <li>You can cancel the SMS service at any time. Just text "STOP" to the 10DLC number. After you send the SMS message "STOP" to us, we will send you an SMS message to confirm that you have been unsubscribed. After this, you will no longer receive SMS messages from us. If you want to join again, just sign up as you did the first time and we will start sending SMS messages to you again.</li>
                <li>If you are experiencing issues with the messaging program you can reply with the keyword HELP for more assistance, or you can get help directly at catastrobeemovie@gmail.com.</li>
                <li>Carriers are not liable for delayed or undelivered messages</li>
                <li>As always, message and data rates may apply for any messages sent to you from us and to us from you. You will receive about 2 messages per week. If you have any questions about your text plan or data plan, it is best to contact your wireless provider.</li>
                <li>If you have any questions regarding privacy, please read our privacy policy: catastrobee.com/privacy</li>
            </ol>
        </main>
    </div>
  );
}

export default Terms;